import { CARD_PROVIDER_LABELS, type BankCode, type CashMovement } from './mock-data'
import type { OutflowKey, TakeoutReason } from './drawer-float'
import type { Key, T } from './i18n'

/**
 * The drawer's words on SCREEN, in the interface language. The Z-report, the
 * journal and the morning mail keep `takeoutLabel` / `movementLabel` from
 * drawer-float — documents stay Georgian — and i18n.test.ts holds the
 * Georgian of both pairs equal, so they cannot drift apart.
 */

/** „ბანკში (TBC)" / „В банк (TBC)". */
export function takeoutText(t: T, reason: TakeoutReason | null | undefined, bank?: BankCode | null): string {
  const r = reason ?? 'other'
  const base = t(`takeout.${r}` as const)
  return r === 'bank' && bank ? `${base} (${CARD_PROVIDER_LABELS[bank]})` : base
}

/** Where the drawer's cash went (drawerOutflows): „ბანკში — TBC" / „В банк — TBC". */
export function outflowText(t: T, key: OutflowKey): string {
  if (key === 'bank_unnamed') return t('outflow.bankUnnamed')
  if (key.startsWith('bank_')) return t('outflow.bank', { bank: CARD_PROVIDER_LABELS[key.slice(5) as BankCode] })
  return t(`outflow.${key}` as Key)
}

/** „ბანკში შეტანა (TBC)" / „В банк (TBC)". */
export function movementText(t: T, m: Pick<CashMovement, 'reason' | 'bank' | 'doc'>): string {
  if (m.doc) return t(`cashdoc.${m.doc}` as const)
  const base = t(`reason.${m.reason}` as const)
  return m.reason === 'bank' && m.bank ? `${base} (${CARD_PROVIDER_LABELS[m.bank]})` : base
}
